import { render, staticRenderFns } from "./Products.vue?vue&type=template&id=2611d894&scoped=true"
import script from "./Products.vue?vue&type=script&lang=js"
export * from "./Products.vue?vue&type=script&lang=js"
import style1 from "./Products.vue?vue&type=style&index=1&id=2611d894&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2611d894",
  null
  
)

export default component.exports